<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-11 08:57:14
 * @LastEditTime : 2024-02-04 15:05:02
 * @LastEditors  : yangxr
 * @Description  : 库存仓控制
 * @FilePath     : \icps_fb1\src\views\platform\ICPS\smart\warehouseControl.vue
-->
<template>
  <div v-loading="loading" class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">站点</span>
              <el-select v-model="tableParam.stationId" style="width: 150px" clearable placeholder="请输入">
                <el-option v-for="(item, index) in stationIdlist" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="queryWarehourse()">查 询</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div class="card_info" :style="style">
            <div style="display: flex">
              <div class="warehouse-list" style="margin-top: 30px">
                <div class="warehouse-name">库存仓名称</div>
                <div class="warehouse-name" style="margin-top: 10px">当前库存量</div>
                <div class="warehouse-content" style="background: #ffffff"></div>
                <div class="warehouse-rawInventory">满仓量</div>
                <div class="warehouse-status">卸料控制</div>
                <div class="warehouse-status">吹灰口控制</div>
                <div class="warehouse-car">待卸料车辆</div>
              </div>
              <div class="warehouse-container">
                <div v-for="(item, index) in warehouseList" :key="index" class="warehouse-list">
                  <div
                    class="warehouse-name"
                    style="font-size: 15px"
                    :style="{
                      color: item.sumInventory < 0 || item.isMoreThan ? '#ff0000' : '',
                    }"
                  >
                    {{ item.rawList[0].warehouseName }}
                  </div>
                  <div
                    class="warehouse-name"
                    :style="{
                      color: item.sumInventory < 0 || item.isMoreThan ? '#ff0000' : '',
                      marginTop: '10px',
                    }"
                  >
                    {{ item.sumInventory.toFixed(2) }}吨
                  </div>
                  <el-tooltip placement="left">
                    <div slot="content" v-html="item.content"></div>
                    <div class="warehouse-content">
                      <div v-if="item.sumInventory > 0" style="height: 100%">
                        <div v-if="item.isMoreThan" style="height: 100%; display: flex; flex-direction: column-reverse">
                          <div
                            v-for="(items, index2) in item.rawList"
                            :key="index2"
                            class="material-list"
                            :style="{
                              height: (items.rawInventory / item.sumInventory) * 100 + '%',
                              background: colorList[index2],
                            }"
                          ></div>
                        </div>
                        <div v-if="!item.isMoreThan" style="height: 100%; display: flex; flex-direction: column-reverse">
                          <div
                            v-for="(items, index2) in item.rawList"
                            :key="index2"
                            class="material-list"
                            :style="{
                              height: (items.rawInventory / item.rawList[0].maxInventory) * 100 + '%',
                              background: colorList[index2],
                            }"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </el-tooltip>
                  <div
                    class="warehouse-rawInventory"
                    :style="{
                      color: item.sumInventory < 0 || item.isMoreThan ? '#ff0000' : '',
                    }"
                  >
                    {{ item.rawList[0].maxInventory ? item.rawList[0].maxInventory.toFixed(2) : 0 }}吨
                  </div>
                  <div class="warehouse-status">
                    <el-switch v-model="item.enableControl" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="updateEnable(item.warehouseId, item.enableControl)"> </el-switch>
                  </div>
                  <div class="warehouse-status">
                    <el-link type="danger" :underline="false" @click="operateAccessControl(item.warehouseId, 0, index, item.carList)">关闭</el-link>
                    <el-link class="table_link" :underline="false" @click="operateAccessControl(item.warehouseId, 1, index)">打开</el-link>
                  </div>
                  <div class="warehouse-car">
                    {{ item.carList }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryWarehourse, updateEnable, operateAccessControl } from "@/api/smart/warehouseControl.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  data() {
    return {
      disabledType: false,
      /*表格增删改查及下载接口*/
      loading: false,
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      warehouseList: [],
      colorList: ["#ffda20", "#049dee", "#65ad02", "#ff9999", "#ffb399", "#ffcc99"],
      stationIdlist: [],
    };
  },
  watch: {},
  async created() {
    this.stationIdlist = await getUserAutList(true);
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { stationId: "" };
  },
  methods: {
    operateAccessControl(id, type, index, carList) {
      if (type == 0 && carList) {
        this.$message.warning("存在待卸料车辆不允许关闭！");
        return;
      }
      this.$confirm(`是否${type == 0 ? "关闭" : "打开"}该吹灰口?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          operateAccessControl({ repertoryId: id, command: type })
            .then(res => {
              if (res.code == 1001) {
                this.$message.success("操作成功!");
                this.$refs.popover[index].doClose();
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    queryWarehourse() {
      queryWarehourse(this.tableParam).then(res => {
        if (res.code == 1001) {
          res.data?.forEach(item => {
            let content = "";
            let sumInventory = 0;
            let carList = "";
            item.rawList?.forEach(items => {
              sumInventory += items.rawInventory;
              content = `${content}${items.rawName}<br/>库存量：${items.rawInventory}吨<br/><br/>`;
            });
            item.carNoList?.forEach(items => {
              carList = carList ? carList + "/" + items : items;
            });
            item["content"] = content;
            item["sumInventory"] = sumInventory;
            item["carList"] = carList;
            item["isMoreThan"] = sumInventory > item.maxInventory;
          });
          this.warehouseList = res.data;
        }
      });
    },
    updateEnable(id, enableControl) {
      updateEnable({ id: id, enableControl: enableControl }).then(() => {
        this.queryWarehourse();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.warehouse-container {
  display: flex;
  overflow-x: scroll;
}
.warehouse-list {
  text-align: center;
  margin: 30px 10px;
  .warehouse-name {
    font-size: 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .warehouse-content {
    background: #e5e5e5;
    height: 200px;
    width: 100px;
    margin: 30px 0 10px;
    flex-direction: row;
    position: relative;
    .fixed-center {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 70%;
      height: 20px;
      background: #fff;
      text-align: center;
      font-size: 15px;
      border-radius: 10px;
    }
  }
  .warehouse-rawInventory {
    font-size: 15px;
    margin-top: 30px;
  }
  .warehouse-status {
    font-size: 15px;
    margin-top: 30px;
  }
  .warehouse-car {
    font-size: 15px;
    margin-top: 30px;
  }
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>